<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.prestationEtablissement') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-container>
                    <div class="row justify-content-center">
                        <div class="col-8">
                            <div class="timeline-box h-100">
                                <div class="box-title">
                                    <i class="fa fa-list medsur-primary-color" aria-hidden="true"></i>
                                    {{ $t('message.prestationDetail') }}
                                </div>
                                <div class="box-content">
                                    <div class="box-item column-display-style">
                                        <div class="row">
                                            <div class="col-6 text-right">
                                                <p><strong>{{ $t('message.nomEtablissement') }}</strong></p>
                                            </div>
                                            <div class="col-6 text-left">
                                                <p>{{ etablissement }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 text-right">
                                                <p><strong>{{ $t('message.nomDeLaCategorie') }}</strong></p>
                                            </div>
                                            <div class="col-6 text-left">
                                                <p>{{ categorie }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 text-right">
                                                <p><strong>{{ $t('message.nomPrestation') }}</strong></p>
                                            </div>
                                            <div class="col-6 text-left">
                                                <p>{{ nom }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 text-right">
                                                <p><strong>{{ $t('message.price') }}</strong></p>
                                            </div>
                                            <div class="col-6 text-left">
                                                <p>{{ _displayNumber(mPrestation.prix) }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6 text-right">
                                                <p><strong>{{ $t('message.reduction') }}</strong></p>
                                            </div>
                                            <div class="col-6 text-left">
                                                <p>{{ _displayNumber(mPrestation.reduction) }}</p>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-6 text-right">
                                                <b-button
                                                    size="sm"
                                                    variant="primary"
                                                    @click="updatePrestation"
                                                >
                                                    {{ $t('message.edit') }}
                                                </b-button>
                                            </div>
                                            <div class="col-6 text-left">
                                                <b-button
                                                    size="sm"
                                                    variant="danger"
                                                    v-b-modal.delete-modal
                                                >
                                                    {{ $t('message.delete') }}
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box-footer">
                                </div>
                            </div>
                        </div>

                        <b-modal
                                id="delete-modal"
                                size="sm"
                                header-bg-variant="danger"
                                header-text-variant="light"
                                :title="$t('message.delete') + ' ' + $tc('message.prestation',1)"
                                hide-footer
                        >
                            <div class="d-block text-center">
                                <h3>{{ $t('message.delete') }} {{ mPrestation.prestation.nom }}?</h3>
                            </div>

                            <div class="d-block float-right">
                                <b-button variant="danger" @click="deletePrestation">
                                    {{ $t('message.delete') }}
                                </b-button>

                                <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                    {{ $t('message.cancel') }}
                                </b-button>
                            </div>
                        </b-modal>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';
	import { displayNumber } from "../../helpers/general";

    export default {
        name: "Show",

        computed: {
            ...mapGetters(["etablissementPrestation", 'hasAdminRole',
                'hasGestionnaireRole', 'hasMedecinControleRole','isComptable']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable;
            },

            mPrestation:function () {
                return this.etablissementPrestation;
            },

            etablissement:function(){
                if (this.mPrestation.hasOwnProperty('etablissement')){
                    return this.mPrestation.etablissement.name;
                }
                return '';
            },

            categorie:function(){
                if (this.mPrestation.hasOwnProperty('prestation')){
                    if (!_.isNull(this.mPrestation.prestation.categorie)){
                        return this.mPrestation.prestation.categorie.nom;
                    }
                    return this.$i18n.t('message.nonDefinie');
                }
                return this.$i18n.t('message.nonDefinie');
            },

            nom:function(){
                if (this.mPrestation.hasOwnProperty('prestation')){
                    if (!_.isNull(this.mPrestation.prestation)){
                      return   this.mPrestation.prestation.nom
                    }
                    return this.$i18n.t('message.nonDefinie');
                }
                return this.$i18n.t('message.nonDefinie');
            }
        },

        data() {
            return {
                prestation_id: this.$route.params.prestation_etablissement,
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [10, 15, 20]
                },
            }
        },

        methods: {
            updatePrestation(){
                this.$router.push({ name: 'edit-etablissement-prestations', params: { prestation_etablissement: this.prestation_id } });
            },

            getPrestation() {
                let args = {
                    prestation: this.prestation_id,
                };
                this.$store.dispatch("getEtablissementPrestation", {args});
            },

            deletePrestation(){
                let args = {
                    prestation: this.prestation_id,
                };

                let successMessage = this.$i18n.t('message.prestationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteEtablissementPrestation', {args, successMessage, errorMessages})
            },

			_displayNumber: displayNumber,
        },

        mounted() {
            this.getPrestation();
        }
    }
</script>

<style scoped lang="scss">
    .box-item {
        p {
            margin-bottom: 0;
        }

        .row {
            margin-bottom: 0.5rem;
        }
    }
</style>
